import * as React from "react";

import { AppEvent } from "../types";

const plaintextDescription = (event: AppEvent): string => {
  const trim = (s: string) =>
    s
      .split("\n")
      .map((l) => l.trim())
      .join("\n");

  switch (event.slug) {
    case "mehendi":
      return trim(`Join us for Snigdha's bridal mehendi and get your hands painted with beautiful designs!

        Recommended attire: Indian or western casual, shades of green preferred.`);
    case "haldi":
      return trim(`The Haldi is a traditional Hindu ceremony where a turmeric (haldi) paste is applied to the bride's face/neck, arms, hands, knees, and feet.

        Recommended attire: Wear your brightest spring colors (yellow and orange)!`);
    case "sangeet":
      return trim(`Kick off the wedding festivities with a fun-filled evening of music, food, and most importantly, dancing! Get ready to dance your heart out and enjoy performances from the couple's friends and family!

        Recommended attire: Dress to dance in Indian attire or western formal/semi-formal!`);
    case "wedding":
      return trim(`Finally the big day! Join us for the wedding ceremony to bless the couple and celebrate their love.

        1:30 PM: Ceremony
        4:30 PM: Cocktail Hour
        6:00 PM: Celebration Dinner

        Recommended attire: Indian or western formal.`);
    case "reception":
      return trim(`Join us in celebrating the newlyweds and their new life together with a night of dancing, food, and fun!

        Recommended attire: Indian or western formal.`);
    default:
      throw new Error(`Unknown event slug: ${event.slug}`);
  }
};

export { plaintextDescription };

const EventDescription = ({
  event,
  detailed,
}: {
  event: AppEvent;
  detailed: boolean;
}) => {
  switch (event.slug) {
    case "mehendi":
      return (
        <>
          <p>
            Join us for Snigdha&apos;s bridal mehendi and get your hands painted
            with beautiful designs!
          </p>
          {detailed && (
            <p>
              Tradition says a rich deep mehendi stain is indicative of a happy
              marriage and lots of love between the couple!
            </p>
          )}
          <p>
            <span className="fw-bolder">Recommended attire:</span> Indian or
            western casual, shades of green preferred.
          </p>
        </>
      );
    case "haldi":
      return (
        <>
          <p>
            The Haldi is a traditional Hindu ceremony where a turmeric (haldi)
            paste is applied to the bride&apos;s face/neck, arms, hands, knees,
            and feet.
          </p>
          {detailed && (
            <p>
              The yellow colour of turmeric is considered very auspicious, and
              the haldi paste is said to make her skin glow and bless the
              marriage.
            </p>
          )}
          <p>
            <span className="fw-bolder">Recommended attire:</span> Wear your
            brightest spring colors (yellow and orange)!
          </p>
        </>
      );
    case "sangeet":
      return (
        <>
          <p>
            Kick off the wedding festivities with a fun-filled evening of music,
            food, and most importantly, dancing! Get ready to dance your heart
            out and enjoy performances from the couple&apos;s friends and
            family!
          </p>
          <p>
            <span className="fw-bolder">Recommended attire:</span> Dress to
            dance in Indian attire or western formal/semi-formal!
          </p>
        </>
      );
    case "wedding":
      return (
        <>
          <p>
            Finally the big day! Join us for the wedding ceremony to bless the
            couple and celebrate their love.
          </p>
          {detailed ? (
            <p className="d-grid wedding-schedule">
              <dt className="fw-bolder">1:30 PM</dt>
              <dd>Ceremony</dd>
              <dt className="fw-bolder">4:30 PM</dt>
              <dd>Cocktail Hour</dd>
              <dt className="fw-bolder">6:00 PM</dt>
              <dd>Celebration Dinner</dd>
            </p>
          ) : (
            <p>
              Afterwards, we will have a cocktail hour (4:30 PM) and celebration
              dinner (6:00 PM) at the same venue.
            </p>
          )}
          <p>
            <span className="fw-bolder">Recommended attire:</span> Indian or
            western formal.
          </p>
        </>
      );
    case "reception":
      return (
        <>
          <p>
            Join us in celebrating the newlyweds and their new life together
            with a night of dancing, food, and fun!
          </p>
          <p>
            <span className="fw-bolder">Recommended attire:</span> Indian or
            western formal.
          </p>
        </>
      );
    default:
      throw new Error(`Unknown event slug: ${event.slug}`);
  }
};

export default EventDescription;
